export const HARDWARE_CHECKLIST = "HARDWARE_CHECKLIST";
export const TS_LIST = "TS_LIST";
export const CHALLAN_ITEMS = "CHALLAN_ITEMS";
